(() => {
  if (window.AliencellHalloweenTop) {
    window.AliencellHalloweenTop.init(document);
    return;
  }

  const instances = new Map();

  function mount(root) {
    if (instances.has(root)) return;
    const nav = root.querySelector('[data-halloween-nav]');
    if (!nav) return;

    const controller = new AbortController();
    const { signal } = controller;
    const links = [...nav.querySelectorAll('[data-halloween-nav-link]')];
    let frame = null;
    let observedPromo = null;
    let promoOffset = 0;

    function updateNav() {
      frame = null;
      const promo = document.getElementById('epb_background');
      if (promo !== observedPromo) {
        if (observedPromo) resizeObserver?.unobserve(observedPromo);
        if (promo) resizeObserver?.observe(promo);
        observedPromo = promo;
      }
      const style = promo && getComputedStyle(promo);
      const rect = promo?.getBoundingClientRect();
      const offset = style?.position === 'fixed' && style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 ? Math.max(0, rect.bottom) : 0;
      promoOffset = offset;
      root.style.setProperty('--a-halloween-promo-height', `${offset}px`);
      root.style.setProperty('--a-halloween-nav-height', `${nav.getBoundingClientRect().height}px`);
      const marker = offset + nav.getBoundingClientRect().height + 4;
      let active = links[0];
      links.forEach((link) => {
        const target = document.getElementById(link.hash.slice(1));
        if (target && target.getBoundingClientRect().top <= marker) active = link;
      });
      links.forEach((link) => {
        if (link === active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }

    function requestUpdate() {
      if (frame === null) frame = requestAnimationFrame(updateNav);
    }

    const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(requestUpdate) : null;
    resizeObserver?.observe(nav);
    window.addEventListener('scroll', requestUpdate, { passive: true, signal });
    window.addEventListener('resize', requestUpdate, { passive: true, signal });
    root.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#halloween-"]');
      if (!link || !root.contains(link) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = document.getElementById(link.hash.slice(1));
      if (!target || !root.contains(target)) return;
      event.preventDefault();
      updateNav();
      const top = window.scrollY + target.getBoundingClientRect().top - nav.offsetHeight - promoOffset;
      window.scrollTo({ top: Math.max(0, top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }, { signal });
    requestUpdate();

    instances.set(root, () => {
      controller.abort();
      resizeObserver?.disconnect();
      if (frame !== null) cancelAnimationFrame(frame);
      instances.delete(root);
    });
  }

  function init(scope) {
    if (scope.matches?.('[data-halloween-landing]')) mount(scope);
    scope.querySelectorAll('[data-halloween-landing]').forEach(mount);
  }

  window.AliencellHalloweenTop = { init };
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((destroy, root) => {
      if (event.target === root || event.target.contains(root)) destroy();
    });
  });
  init(document);
})();
